import styled from 'styled-components';

export default styled.table`
    border-spacing: 0;

    & tbody > tr {
        border-bottom: ${({ showbordersbetweenrows }) => (showbordersbetweenrows ? '1px solid #cfcfcf' : 'none')};
    }

    & td {
        padding: 5px 15px;
        font-size: 12px;
        text-align: center;
    }

    & th,
    & tfoot td {
        color: #9b9b9b;
        font-size: 10px;
        padding: 5px 15px;
        & > *:first-child {
            font-weight: bold;
        }
    }

    & td:first-child,
    & th:first-child {
        text-align: left;
        border-right: 1px solid #aaaaaa;
    }

    & .nonGuaranteedCell {
        color: #9b9b9b;
        font-size: 10px;
        font-style: italic;
    }
`;
